// extracted by mini-css-extract-plugin
export default {"dashboardButtons":"Dashboard_dashboardButtons__0auM8","dashboardButton":"Dashboard_dashboardButton__NSRDN","dashboardChart":"Dashboard_dashboardChart__b96Ms"};